// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1jFED","errorLogs":"EditorFooter_errorLogs__2TJbu"};